import { PromoBannerType } from "@faire/retailer-visitor-shared/components/Notifications/PromoBanner/bannerOrder";
import { usePaymentTerm } from "@faire/retailer-visitor-shared/hooks/retailer/usePaymentTerm";
import { specialHolidayNet90Active } from "@faire/retailer-visitor-shared/settings/getSettingSpecialHolidayNet90";
import { useCreditSummary } from "@faire/retailer-visitor-shared/stores/domain/useCreditSummary";
import { usePromoBanners } from "@faire/retailer-visitor-shared/stores/ui/usePromoBanners";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
export var useFOIBannerOrder = function() {
    var isRetailerOnNetTerms = usePaymentTerm().isRetailerOnNetTerms;
    var isLoading = useCreditSummary().isLoading;
    var showOpenWithFaireEligibleToApplyBanner = usePromoBanners().showOpenWithFaireEligibleToApplyBanner;
    var showPaymentTermsBanner = isRetailerOnNetTerms && !specialHolidayNet90Active() && !showOpenWithFaireEligibleToApplyBanner && !isLoading;
    var banners = [
        PromoBannerType.FIRST_ORDER_INCENTIVE,
        showOpenWithFaireEligibleToApplyBanner ? PromoBannerType.OPEN_WITH_FAIRE : undefined,
        showPaymentTermsBanner ? PromoBannerType.PAYMENT_TERMS : undefined
    ].filter(isNotUndefined);
    return banners;
};
